import { sendClickEvent } from './sendClickEvent/index.js';
import { sendPageDataEvent } from './sendPageDataEvent/index.js';
import { sendImpressions } from './sendImpressions/index.js';
import { getGoogleConfiguration, setGoogleConfiguration } from './googleConfiguration.js';
export default {
  getGoogleConfiguration,
  setGoogleConfiguration,
  sendClickEvent,
  sendPageDataEvent,
  sendImpressions
};